export default {
  computed: {
    dateFormat() {
      return this.$store.state.user.user.language === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
    },
  },
};
